export const REGION_REDIRECT_URL =
	'https://region-redirect.secoda.workers.dev/redirect/get';
